import { render, staticRenderFns } from "./VueHeader.vue?vue&type=template&id=bc0d9e4e&scoped=true&"
import script from "./VueHeader.vue?vue&type=script&lang=js&"
export * from "./VueHeader.vue?vue&type=script&lang=js&"
import style0 from "./VueHeader.vue?vue&type=style&index=0&id=bc0d9e4e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0d9e4e",
  null
  
)

export default component.exports